<template>
    <dashboard-layout tit="마이스펙 이력 관리" fullHeight>
        <template slot="contents">
            <template v-if="items.length">
                <p class="page-text--sm grey-6--text mb-12 mb-lg-20">마이스펙 이력은 해당 지원자의 역량이 마이스펙을 통해 인증되었다는 것을 증명합니다</p>
                <v-divider class="primary border-2" />
                <micepec-record-item v-for="item in items" :key="item._id" v-bind="{ item }" mode="view" class="mt-12 mt-lg-24" />
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 사용자님. <br />
                        마이스펙 이력이 없습니다.
                    </p>
                    <v-btn href="/recruitments" text height="auto" color="transparent">
                        <span class="grey-9--text">마이스펙 이력쌓기</span>
                    </v-btn>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
    <!-- <v-layout column justify-center>
        <v-card-text class="fill-height pa-lg-60 pa-30" style="overflow: auto">
            <v-card-subtitle class="px-0 page-text--sm"> 마이스펙 이력은 해당 지원자의 역량이 마이스펙을 통해 인증되었다는 것을 증명합니다 </v-card-subtitle>
            <v-divider class="primary mb-24" />
            <template v-if="items.length">
                <micepec-record-item v-for="item in items" :key="item._id" v-bind="{ item }" mode="view" class="mb-24" />
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-16" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="text-center text-h4 font-weight-bold" style="height: calc(100% - 50px - 16px); line-height: 1.4">
                    안녕하세요, 사용자님. <br />
                    마이스펙 이력이 없습니다.
                    <v-btn x-large color="primary" class="my-24" href="/recruitments"> 마이스펙 이력쌓기 </v-btn>
                </v-layout>
            </template>
        </v-card-text>
    </v-layout> -->
</template>

<script>
import api from "@/api";
import { APPLICATION_STATES } from "@/assets/variables";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import MicepecRecordItem from "@/components/client/application/micepec-records/micepec-record-item.vue";

export default {
    components: {
        DashboardLayout,
        MicepecRecordItem,
    },
    data: () => ({
        loading: false,
        applications: [],

        limit: 10,
        summary: { totalCount: 0 },
    }),
    computed: {
        items() {
            return this.applications.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            query.state = APPLICATION_STATES.ON_RECRUIT.value;
            query.isCertified = true;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, applications } = await api.v1.person.recruitmentApplications.gets({
                    headers: { skip, limit },
                    params,
                });

                this.applications = applications;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
